import { GoogleSettingKey } from '$extensionSrc/recommendations/recommendationSettingsKeys'
import { GoogleRecommendationKey, StageType } from '$extensionSrc/utils/enums'

import { StageDef } from '../automationMachineInterfaces'
import {
  defaultCantUndoFn,
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
  getCurrentValueFnFromKey,
  getIsFulfilledFnFromKey,
} from '../recommendationCardDisplayUtils'
import { getOptionalElement } from '../utils'
import {
  getCaseInsensitiveString,
  getCaseInsensitiveXPathTextSelector,
} from '../xpath'
import { GOOGLE_AUTOMATION_STAGE_STATUSES } from './googleAutomationStageStatuses'
import * as googleUrls from './googleUrls'

/**
 * Check the user's two-factor authentication by looking for specific text
 * (present on buttons & headers).
 */
export async function get2faIsOn() {
  const ifOn = `
    //*[${getCaseInsensitiveXPathTextSelector('aria-label', '2-step verification')}]
    /descendant::*[
      starts-with(${getCaseInsensitiveString('text()')}, "on")
    ]
  `
  const ifOff = `
    //*[${getCaseInsensitiveXPathTextSelector('aria-label', '2-step verification')}]
    /descendant::*[
      contains(${getCaseInsensitiveString('text()')}, "off")
    ]
  `

  return Promise.any([
    getOptionalElement(document, ifOn).then((e) => {
      if (!e) {
        throw new Error('failed to find 2fa on')
      } else {
        return true
      }
    }),
    getOptionalElement(document, ifOff).then((e) => {
      if (!e) {
        throw new Error('failed to find 2fa off')
      } else {
        return false
      }
    }),
  ])
}

export const getCurrentValueFn = (key) =>
  getCurrentValueFnFromKey(
    key,
    (value) => value?.[GoogleSettingKey.TWOFA] || undefined,
  )
export const getIsFulfilledFn = (key) =>
  getIsFulfilledFnFromKey(key, (value) => value)
export const getCantUndoFn = () => defaultCantUndoFn
export const getIsDisabledFn = () => defaultIsDisabledFn
export const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

enum StageKey {
  GATHER_SETTING_2FA = 'GATHER_SETTING_2FA',
}

export const gatherStageDefs: StageDef[] = [
  {
    type: StageType.ACTION,
    key: StageKey.GATHER_SETTING_2FA,
    status: GOOGLE_AUTOMATION_STAGE_STATUSES.GATHERING_SETTINGS,
    action: async (_machineContext, userContext) => {
      const { googleAccountIndex } = userContext
      googleUrls.securityUrl.navigateForUser(googleAccountIndex)

      const { updateStoredInitialValues } = userContext

      const isOn = await get2faIsOn()

      await updateStoredInitialValues(
        {
          [GoogleSettingKey.TWOFA]: isOn,
        },
        GoogleRecommendationKey.GOOGLE_2FA,
      )
    },
  },
]
export const updateStageDefs: StageDef[] = []
export const undoStageDefs: StageDef[] = []
